import { Component, OnInit } from '@angular/core';
import { Sr } from '../../interfaces/sr';
import {SrService} from '../../service/sr.service';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../CookieAuth/auth.service';
import { promise } from 'selenium-webdriver';
import { MatDialog } from '@angular/material/dialog';
import { SrFormComponent } from '../../components/sr-form/sr-form.component';
import { EtFormComponent } from '../../components/et-form/et-form.component';

import { EtEnvioFormComponent } from '../../components/et-envio-form/et-envio-form.component';
import { EstadoService } from 'src/app/service/estado.service';

import {Cell, Columns, Img, PdfMakeWrapper, QR, Table, Txt} from 'pdfmake-wrapper';
import { Column, TableCell } from 'pdfmake/interfaces';

@Component({
  selector: 'app-sr-historico',
  templateUrl: './sr-historico.component.html',
  styleUrls: ['./sr-historico.component.css']
})
export class SrHistoricoComponent implements OnInit {
  public estados?:any[];
  name:string="Mariano test";
  idsr:number=0;
  idet:number=0;
  dni:number=0;
  desde:Date=new Date();
  hasta:Date=new Date();
  estado:number=0;
  public sr?: any[];
  constructor(private srService:SrService, private cookie: AuthService, private dialog: MatDialog,private estadoService:EstadoService) { }

  ngOnInit(){
    this.estados=this.estadoService.get()
    this.desde.setFullYear(2020)
    this.cookie.checkExistCookie().then((data:boolean) => {
      if (data) {
        this.srService.getHistorico(this.idsr,this.idet,this.dni,this.desde,this.hasta,this.estado).then(async (data:any[]) =>{
          // return data;
          this.sr=data;
          console.log(this.sr);
        });
      } else {
        //Hacer el maldito redirect....
        // console.log("home devuelve")
        window.location.href = "/";
      }
    });


  }

  modificar(id:number){

  }
  cambiarEstado(id:number, idEstado:number){

    // return this.srService.postNewEstado(id,idEstado).then(data =>{

    //   if(data='ok'){
    //     this.srService.getPendientes().subscribe((data:any[]) =>{
    //       // return data;
    //       this.sr=data;

    //     });
    //     return true;
    //   }else
    //   {
    //     return false;
    //   }
    // });

  }
abrirEt(id_sr:number){
  let dialogRef = this.dialog.open(EtFormComponent, {
    data: {id_sr: id_sr},
    maxHeight: '90vh'
  });
  dialogRef.afterClosed().subscribe(result => {
    console.log('The dialog was closed', result);
    this.buscar();
  });
}
abrirEtM(id_et:number, id: number){
  let dialogRef = this.dialog.open(EtEnvioFormComponent, {
    data: {id_et: id_et , id: id},
    maxHeight: '90vh'
  });
  dialogRef.afterClosed().subscribe(result => {
    console.log('The dialog was closed', result);
    this.buscar();
  });
}
  open(id:number){
    // const scrollStrategy = this.overlay.scrollStrategies.reposition();
    let dialogRef = this.dialog.open(SrFormComponent, {
      data: {id: id},
      maxHeight: '90vh'
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed', result);
      this.srService.getHistorico(this.idsr,this.idet,this.dni,this.desde,this.hasta,this.estado).then((data:any[]) =>{
        // return data;
        this.sr=data;

      });

    });

  }

  buscar(){
    this.cookie.checkExistCookie().then((data:boolean) => {
      if (data) {
        this.srService.getHistorico(this.idsr,this.idet,this.dni,this.desde,this.hasta,this.estado).then(async (data:any[]) =>{
          // return data;
          this.sr=data;
          console.log(this.sr);
        });
      } else {
        //Hacer el maldito redirect....
        // console.log("home devuelve")
        window.location.href = "/";
      }
    });
  }

  // async crearpdf(){


  //   const pdf =new PdfMakeWrapper();
  //   let logo= await new Img('assets/crabs-logo-small.png').alignment('center').opacity(0.4).build();
  //   pdf.background(logo);

  //   let prueba: Column[];
  //   // prueba=new Array<Column>{}

  //   pdf.add(this.createTableOrigen(await new Img(logo.image).height(45).width(40).build()));//info del destinatario
  //     pdf.add(new Table([
  //       ['Bulto','Descripcion', 'Peso','Valor'],
  //       ...this.extraerData()
  //     ]).layout('lightHorizontalLines').alignment('center').end);// info de los bultos

  //     pdf.add(this.createTableDestino())//info del destino

  //     pdf.footer(new Table([
  //       ['Firma Remitente: ','','Firma Conductor: ',''],
  //       ['','','',''],['','','',''],['','','',''],['','','',''],['','','',''],['','','',''],['','','',''],['','','',''],['','','',''],['','','',''],['','','',''],['','','',''],['','','',''],
  //       ['Aclaracion Remitente: ','','Aclaracion Conductor: ','']

  //     ]).alignment('justify').widths(['*',100,'*',100])
  //     .heights((row:number) =>{return row+100} )
  //     .layout('noBorders')
  //     .end
  //     );
  //     pdf.pageMargins([40,40,40,100])
  //     pdf.add(new QR('http://manager.crabslogistica.ar/cliente/'+this.sr.id+'/0').alignment('center').end)
  //   pdf.create().open();

  // }
}
